<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>
<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    props: {
    echartsData: {
      type: Object
    },
    active:String
  },
    setup(props) {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            tooltip: {
              trigger: 'axis',
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            legend: {
              data: [props.active],
            },
            xAxis: {
              type: "category",
              data: props.echartsData.timeData,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: props.active,
                data: props.echartsData.lineList,
                barWidth: '50%',
                type: "bar",
                itemStyle: {
                  normal: {
                    color: "#437BB7",
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>